import React from 'react';

const Favicon: React.FC = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_ii_161_100)">
        <rect width="32" height="32" rx="8" fill="#17E3B4" />
      </g>
      <rect
        x="0.444444"
        y="0.444444"
        width="31.1111"
        height="31.1111"
        rx="7.55556"
        stroke="#020511"
        strokeOpacity="0.1"
        strokeWidth="0.888889"
      />
      <rect
        x="6.22103"
        y="17.9019"
        width="18.4339"
        height="2.69764"
        rx="1.34882"
        fill="white"
      />
      <rect
        x="6.22103"
        y="12.5065"
        width="11.2402"
        height="2.69764"
        rx="1.34882"
        fill="white"
      />
      <rect
        x="10.2678"
        y="23.297"
        width="5.84489"
        height="2.69764"
        rx="1.34882"
        fill="white"
      />
      <rect
        x="6.22103"
        y="7.11133"
        width="18.4339"
        height="2.69764"
        rx="1.34882"
        fill="white"
      />
      <rect
        x="20.1572"
        y="12.5065"
        width="4.49607"
        height="2.69764"
        rx="1.34882"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_ii_161_100"
          x="-3.55556"
          y="-3.55556"
          width="35.5556"
          height="39.1111"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.55556" />
          <feGaussianBlur stdDeviation="1.77778" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_161_100"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-3.55556" dy="-3.55556" />
          <feGaussianBlur stdDeviation="1.77778" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_161_100"
            result="effect2_innerShadow_161_100"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Favicon;
